module.exports = __webpack_public_path__ + "img/Flow_kuraray_CN@3x.675711bf.png";